import { IoMdClose } from 'react-icons/io';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${({ theme }) => theme.filters.background};
`;

export const Content = styled.div`
  flex: 1;
  height: 100%;
  padding: 55px 0 60px;
`;

export const SearchButton = styled(Button)`
  width: calc(100% - 32px);
  font-size: 16px;
  margin: 16px 16px 20px;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  background: ${ColorPalette.HEX.White};
  position: fixed;
  bottom: 0;
  left: 0;
`;

export const ClearButton = styled.button`
  background: ${ColorPalette.Transparent};
  color: ${({ theme }) => theme.primaryBackgroundColor};
  font-size: 16px;
  z-index: 3;

  &:disabled {
    color: ${ColorPalette.HEX.Manatee};
  }
`;

export const Header: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  border-bottom: 1px solid ${ColorPalette.HEX.Cultured};
  padding: 20px 16px 16px;
  position: fixed;
  width: 100%;
  background: ${ColorPalette.HEX.White};
  margin: -17px -16px 0;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
`;
Header.Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${ColorPalette.HEX.PineTree};
  line-height: normal;
  position: absolute;
  text-align: center;
  margin: 0 auto;
  width: calc(100% - 32px);
  box-sizing: content-box;
  z-index: 1;
`;

export const Close: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 3;
`;
Close.Icon = styled(IoMdClose)`
  font-size: 25px;
  color: ${ColorPalette.HEX.PineTree};
`;
